/**
 * Enum for message component type
 *
 * Type "form" is used for form components inside a modal, refer to SD-5939.
 * Type "inline_click_action" is used for inline click actions inside a message, refer to SD-7431.
 *
 * @lastmodifiedBy PM
 * @lastmodifiedDate 2024-10-15 (YYYY-MM-DD)
 */
export enum MESSAGE_COMPONENT_TYPE {
    Text = "text",
    Image = "image",
    Line = "line",
    Break = "break",
    Button = "button",
    Link = "link",
    Form = "form",
    Carousel = "carousel",
    InlineClickAction = "inline_click_action",
    Markdown = "markdown",
    Html = "html",
}

/**
 * Enum for modal form component type
 *
 * SD-5939: New enum added to handle form components inside a modal.
 *
 * @lastmodifiedBy PM
 * @lastmodifiedDate 2024-10-15 (YYYY-MM-DD)
 */
export enum FORM_COMPONENT_TYPE {
    HeaderText = "header_text",    // Added new type for Form header text
    HeaderImage = "header_image",  // Added new type for Formheader image
    FooterText = "footer_text",     // Added new type for Form footer text
    NumberSpinner = "number_spinner", // Added new type for Form item number spinner
}
